'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('App error:', error);
    
    // For specific errors, try to auto-recover
    if (
      error.message.includes('Target container is not a DOM element') ||
      error.message.includes('hydration')
    ) {
      // Auto-recover from hydration errors
      setTimeout(() => {
        reset();
      }, 1000);
    }
  }, [error, reset]);

  // Filter out specific errors we want to completely hide
  if (
    error.message.includes('Target container is not a DOM element') ||
    error.message.includes('hydration') ||
    error.message.includes('Minified React error #299')
  ) {
    // Return a minimal loading state instead of an error
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // For other errors, show a user-friendly error UI
  return (
    <div className="min-h-screen bg-blue-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
        <div className="text-blue-500 text-6xl mb-4">⚙️</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Just a moment</h1>
        <p className="text-gray-600 mb-4">
          We&apos;re setting things up for you. Please wait a moment or try refreshing the page.
        </p>
        <button
          onClick={reset}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors mr-2"
        >
          Try Again
        </button>
        <button
          onClick={() => window.location.reload()}
          className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}